(function ($, undefined) {
    // ## Options ## - The default options for this plugin
    // 'country' - Grouping of places to which you would like to restrict your results.  Currently, you can use components to filter by country (as two character). 
    // 'callback' - The callback function to invoke when suggested address is selected by the user.
    // 'types' - Restrict results from a Place Autocomplete request to be of a certain type by passing a types parameter [https://developers.google.com/places/webservice/autocomplete#place_types]
    // 'autopopulate' - Flag indicating whether to populate selected address data to provided form fields.
    // 'fieldsMapping' - Object containing fields mapping { addressComponent: fieldSelector }
    //      Supported address components: 'STREET_ADDRESS_AND_NUMBER', 'STREET_ADDRESS', 'STREET_NUMBER', 'COUNTRY', 'ZIP', 'CITY', 'STATE_OR_REGION'
    // 'replaceAutocomplete' - Flag inditcating whether to replace this search box value after user selectes suggested address to street name
    // 'validation' - Object containing validation rules: (null to disable validation)
        // 'componentsToValidate' - An Array of components that must be returned in the response (leave empty array if you don't need validation)
        // 'onValidationFailed' - The callback function to invoke when required address components are not included in the response.

    var defaultOptions = {
        country: null,
        callback: null,
        types: ['address'],
        autopopulate: null,
        fieldsMapping: {},
        replaceAutocomplete: true,
        validation: null
    };

    // Constructor for Address Autocomplete input field
    // The first one is input object for autocomplete
    // and the second one is object of options to set
    function AddressComplete(input, options) {

        this.options = $.extend(true, {}, defaultOptions, options);

        this.input = input;
        this.$input = $(input);

        // Set placeholder attribute to empty, in other case Google adds localized placeholder text by default ['Enter address']
        this.$input.attr('placeholder', '');

        this._defaults = defaultOptions;

        // call initialize function for the input object
        this.init();
    }

    $.extend(AddressComplete.prototype, {
        init: function() {
            this.initAddressComplete();
        },

        googleComponentMapping: {
            'STREET_ADDRESS': 'route',
            'STREET_NUMBER': 'street_number',
            'COUNTRY': 'country',
            'ZIP': 'postal_code',
            'CITY': 'locality',
            'STATE_OR_REGION': 'administrative_area_level_1'
        },

        initAddressComplete: function () {
            var options = { types: this.options.types };

            if (this.options.country) {
                options.componentRestrictions = { country: this.options.country };
            }

            this.autocomplete = new google.maps.places.Autocomplete(
                this.input, options
            );

            // Add listener for 'place changed' event
            google.maps.event.addListener(
                this.autocomplete,
                'place_changed',
                $.proxy(this.placeChangeHandler, this));


            this.$input.on('keypress', function (event) {
                if (event.keyCode === 13) { return false; }
            });
        },

        findComponent: function(place, type) {
            var component = _.find(place.address_components, function(cmp) {
                return _.some(cmp.types, function(t) { return t === type; });
            });
            return typeof component !== 'undefined' ? component : null;
        },

        checkIfExists: function(place, type) {
            return this.findComponent(place, type) !== null;
        },

        validateComponents: function (place) {
            var result = true;
            _.each(this.options.validation.componentsToValidate, function(component) {
                var isValid = this.checkIfExists(place, component);
                if (!isValid) {
                    result = false;
                }
            }, this);
            return result;
        },

        placeChangeHandler: function () {
            var place = this.autocomplete.getPlace();
            this.selected = true;

            if (this.options.replaceAutocomplete) {
                this.$input.val('');
            }

            if (this.options.autopopulate) {
                this.populateAddress(place);
            }

            // Fire callback function (if provided)
            if (this.options.callback) {
                this.options.callback(place, this.$input);
            }

            if (this.options.validation !== null && this.options.validation.componentsToValidate !== null
                && this.options.validation.onValidationFailed !== null && typeof this.options.validation.onValidationFailed === 'function') {
                var validationResult = this.validateComponents(place);
                if (validationResult === false) {
                    this.options.validation.onValidationFailed(this.$input);
                }
            }
        },

        populateAddress: function (place) {
            // Iterate through fields mapping and populate the address components from 'place' object
            for (var fieldMappingKey in this.options.fieldsMapping) {
                var $mappedField = $(this.options.fieldsMapping[fieldMappingKey]);

                if ($mappedField.length === 0) {
                    continue;
                }

                var matchingComponent = {
                    shortName: null,
                    longName: null
                };

                switch (fieldMappingKey) {
                    case 'STREET_ADDRESS_AND_NUMBER':
                        // combine street number and street
                        var streetNumberFirst = true;
                        var streetNumber = this.findComponent(place, this.googleComponentMapping.STREET_NUMBER);
                        if (typeof streetNumber !== 'undefined' && streetNumber !== null) {
                            matchingComponent.longName = streetNumber.long_name;
                            // check how Google formatted the address, there's 'name' property that includes street number and name
                            if (place.hasOwnProperty('name') && place.name.indexOf(streetNumber.long_name) !== 0) {
                                streetNumberFirst = false;
                            }
                        }

                        var street = this.findComponent(place, this.googleComponentMapping.STREET_ADDRESS);
                        if (typeof street !== 'undefined' && street !== null) {
                            if (matchingComponent.longName === null) {
                                matchingComponent.longName = street.long_name;
                            } else if (streetNumberFirst) {
                                matchingComponent.longName += ' ' + street.long_name;
                            } else {
                                matchingComponent.longName = street.long_name + ' ' + matchingComponent.longName;
                            }
                        }
                        break;
                    case 'COUNTRY':
                    case 'ZIP':
                    case 'CITY':
                    case 'STATE_OR_REGION':
                        var key = this.googleComponentMapping[fieldMappingKey];
                        var component = this.findComponent(place, key);
                        if (typeof component !== 'undefined' && component !== null) {
                            matchingComponent.shortName = component.short_name;
                            matchingComponent.longName = component.long_name;
                        }
                        break;
                }

                var fieldType = $mappedField.get(0).tagName;
                var fieldvalue;

                switch (fieldType) {
                    case 'SELECT':
                        if (matchingComponent.shortName !== null) {
                            fieldvalue = matchingComponent.shortName;
                        } else {
                            fieldvalue = $mappedField.find('option:first').val();
                        }
                        break;
                    default:
                        fieldvalue = matchingComponent.longName !== null
                            ? matchingComponent.longName
                            : '';
                        break;
                }

                if ($mappedField.val() !== fieldvalue) {
                    $mappedField.val(fieldvalue);
                    $mappedField.trigger('change.jqueryaddresscomplete');
                }
            }
        }
    });

    // Wrapper for the plugin around the constructor.
    // 'options' - all settings that are different from the default (defined at the top).
    // The 'attr' is used to prevent multiple instantiations of the plugin.
    $.fn.addresscomplete = function (options) {
        var attr = 'plugin.addresscomplete';
        if (typeof options == 'string') {
            var instance = $(this).data(attr) || $(this).addresscomplete().data(attr),
              prop = instance[options];

            if (typeof prop == 'function') {
                prop.apply(instance, Array.prototype.slice.call(arguments, 1));
                return $(this);
            } else {
                if (arguments.length === 2) {
                    prop = arguments[1];
                }
                return prop;
            }
        } else {
            return this.each(function () {
                var instance = $.data(this, attr);                
                if (instance) {
                    if (instance.options.country !== options.country) {
                        options.callback = options.callback || instance.callback;
                        if (typeof google !== 'undefined') {
                            google.maps.event.clearInstanceListeners(this);
                        }
                        
                        instance = new AddressComplete(this, options);
                    }                   
                } else {
                    instance = new AddressComplete(this, options);
                }                
                $.data(this, attr, instance);                
            });
        }
    };

    $.fn.disableAddressComplete = function () {
        var attr = 'plugin.addresscomplete';
        this.each(function() {
            var instance = $.data(this, attr);
            if (instance === undefined) {
                return true;
            }

            $(this).removeData(attr);

            if (typeof google !== 'undefined') {
                google.maps.event.clearInstanceListeners(this);
            }
        });
    }
}(jQuery));
define("plugins/jquery.addresscomplete", ["jquery"], function(){});

